module.exports = __webpack_public_path__ + "static/media/ico-tracking.376ac055.svg";